import { Button } from '@apollo/orbit';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { ampli } from 'src/lib/analytics/amplitude/vendor';

interface VariantEndpointURLProps {
  url?: string | null;
  graphId: string;
  variantName: string;
  onSetEndpoint?: () => void;
}

/**
 * Displays endpoint URL as a clickable link, or a "Set" button if no URL is configured.
 * Used in the supergraphs list table to show/manage variant endpoints.
 */
export const VariantEndpointURL = ({
  url,
  graphId,
  variantName,
  onSetEndpoint,
}: VariantEndpointURLProps) => {
  if (!url) {
    return (
      <Button
        variant="secondary"
        size="xs"
        onClick={() => {
          /* eslint-disable @typescript-eslint/naming-convention */
          ampli.updateEndpointClicked({
            graph_ref: `${graphId}@${variantName}`,
            location: 'graph_list',
          });
          /* eslint-enable @typescript-eslint/naming-convention */
          onSetEndpoint?.();
        }}
        data-testid={`set-endpoint-button-${graphId}-${variantName}`}
      >
        Add endpoint
      </Button>
    );
  }

  return (
    <Tooltip label={url}>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="block max-w-full truncate text-sm text-link"
        data-testid={`endpoint-url-link-${graphId}-${variantName}`}
      >
        {url}
      </a>
    </Tooltip>
  );
};
